import Activities from "assets/img/activity.svg";

const BlockedPage = () => {
  return (
    <div className="w-full h-full flex justify-center items-center bg-02 px-8">
      <div className="flex flex-col justify-center items-center">
        <img
          src={Activities}
          alt="Imagen tu examen ya esta activa en otra pestaña"
        />
        <p className="text-neutral-03 text-heading-02 font-black    mt-8 text-center">
          Ya estás rindiendo tu examen en otra pestaña
        </p>
        <p className="mt-8">
          Por favor, continúa rindiéndolo en la otra ventana
        </p>
      </div>
    </div>
  );
};

export default BlockedPage;
